var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_828_2102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_828_2102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.81744 21C4.29956 21 3.86719 20.8266 3.52031 20.4797C3.17344 20.1328 3 19.7004 3 19.1826V4.81744C3 4.29956 3.17344 3.86719 3.52031 3.52031C3.86719 3.17344 4.29956 3 4.81744 3H19.1826C19.7004 3 20.1328 3.17344 20.4797 3.52031C20.8266 3.86719 21 4.29956 21 4.81744V19.1826C21 19.7004 20.8266 20.1328 20.4797 20.4797C20.1328 20.8266 19.7004 21 19.1826 21H4.81744ZM4.81744 19.875H19.1826C19.3558 19.875 19.5145 19.8029 19.6587 19.6587C19.8029 19.5145 19.875 19.3558 19.875 19.1826V4.81744C19.875 4.64419 19.8029 4.48547 19.6587 4.34128C19.5145 4.19709 19.3558 4.125 19.1826 4.125H4.81744C4.64419 4.125 4.48547 4.19709 4.34128 4.34128C4.19709 4.48547 4.125 4.64419 4.125 4.81744V19.1826C4.125 19.3558 4.19709 19.5145 4.34128 19.6587C4.48547 19.8029 4.64419 19.875 4.81744 19.875Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox_unchecked.b5f49b3d649d1d790ebca322136e1519.svg";
export { ForwardRef as ReactComponent };